/** @format */

import {styled} from '@mui/material/styles';
import {Box, Grid2} from '@mui/material';

export const GridWrap = styled(Grid2)(() => ({
  alignItems: 'center',
  display: 'flex',
}));

export const Footer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));
